import { Component, Inject, Input, OnDestroy, ViewEncapsulation } from '@angular/core';

import { ViewDidEnter, ViewWillEnter } from '@ionic/angular';

import { Subject } from 'rxjs';

import { CatererRating } from '../../core/models/caterer-rating.model';
import { CatererReview } from '../../core/models/review.model';

import { AnalyticsService } from '../../core/services/analytics.service';

import { AnalyticsConfig, TOKEN_ANALYTICS_CONFIG } from '../../core/config/analytics.config';

export const VendorReviewsModalPageIdentifier = 'vendor-reviews-modal';

const REVIEWS_PAGE_SIZE = 20;

@Component({
  selector: 'app-vendor-reviews-modal',
  templateUrl: './vendor-reviews-modal.page.html',
  styleUrls: ['./vendor-reviews-modal.page.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VendorReviewsModalPage implements ViewWillEnter, OnDestroy, ViewDidEnter {
  @Input()
  public vendorId: number;

  @Input()
  public rating: CatererRating;

  @Input()
  public reviews: Array<CatererReview> = [];

  public visibleReviews: Array<CatererReview> = [];

  public areAllReviewsLoaded: boolean;

  private currentPageNumber = 0;
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private analyticsService: AnalyticsService, @Inject(TOKEN_ANALYTICS_CONFIG) private analyticsConfig: AnalyticsConfig) {}

  ionViewWillEnter() {
    this.visibleReviews = this.getNextPageReviews();
  }

  ionViewDidEnter() {
    void this.analyticsService.trackView({
      name: this.analyticsConfig.pageName.vendorReviewsPage,
      data: { [this.analyticsConfig.propertyName.catererId]: this.vendorId },
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  public onLoadMoreReviews(event: Event): void {
    const reviewsNextPage = this.getNextPageReviews();

    this.areAllReviewsLoaded = reviewsNextPage.length === 0;

    if (reviewsNextPage.length) {
      this.visibleReviews.push(...reviewsNextPage);
    }

    if (event.target) {
      void (event.target as HTMLIonInfiniteScrollElement)?.complete();
    }
  }

  private getNextPageReviews(): Array<CatererReview> {
    const reviewsNextPage = !this.reviews
      ? []
      : this.reviews.slice(this.currentPageNumber * REVIEWS_PAGE_SIZE, (this.currentPageNumber + 1) * REVIEWS_PAGE_SIZE);

    this.currentPageNumber++;

    return reviewsNextPage;
  }
}
